import React from 'react';
import { Center, Stack, Title, Text, Button } from '@mantine/core';
import { Link } from 'react-router-dom';

export default function PermissionDenied() {
  return (
    <Center style={{ height: '100vh' }}>
      <Stack align="center">
        <Title order={1} style={{ fontSize: 96 }}>
          403
        </Title>
        <Text size="lg">抱歉，您沒有權限瀏覽此頁面。</Text>
        <Button component={Link} to="/" size="md">
          回到首頁
        </Button>
      </Stack>
    </Center>
  );
}
